"use strict";

exports.__esModule = true;
exports.BindBehaviorsToComponents = void 0;
var _errors = require("../common/errors");
const BindBehaviorsToComponents = ({
  datasetEvents,
  errorReporter,
  api
}) => ({
  dataset,
  components
}) => {
  const executeSafely = ExecuteSafely({
    errorReporter,
    errorMessage: `Failed executing component's method`
  });

  // TODO: in general, behaviors were intended to cover all non data rendering cases.
  // now we have clear distinction between component old behaviors and events.
  // old behaviors are *binding to datasetEvents* and executing component methods in response.
  // old events should just *bind callbacks to components*, that are executed by components themselves.

  // more over, special component handling like GoogleMap etc was intended also to live in new behaviors.
  // so at least one case should be investigated in order to understand where all this going.

  // TODO: refactor this crap after prev TODO resolved!
  for (const component of components) {
    // TODO: add behaviors. not all should be bound as onSubmit
    // TODO: add "many" behaviors support
    const {
      behaviors
    } = component.connection;
    const [behaviorName, behavior] = Object.entries(behaviors).at(0) ?? [];
    if (behaviorName !== 'onSubmit' || !behavior) {
      continue;
    }
    const {
      [behavior.type]: eventName
    } = onSubmitTypesToEventName;
    datasetEvents.on(dataset, 'dataInitialLoadSuccess', () => executeSafely(component.execute, behavior.hide));
    datasetEvents.on(dataset, 'dataLoadSuccess', () => executeSafely(component.execute, behavior.hide));
    datasetEvents.on(dataset, 'recordSaveAttempt', () => executeSafely(component.execute, behavior.hide));
    datasetEvents.on(dataset, 'recordChange', () => executeSafely(component.execute, behavior.hide));
    datasetEvents.on(dataset, eventName, () => executeSafely(component.execute, behavior.show));
  }
  for (const component of components) {
    const {
      connection
    } = component;
    const eventHandlers = makeEventHandlersForBehaviors({
      dataset,
      connection,
      api
    });
    component.bind(eventHandlers);
  }
};
exports.BindBehaviorsToComponents = BindBehaviorsToComponents;
const onSubmitTypesToEventName = {
  success: 'recordSaveSuccess',
  failure: 'recordSaveFailure'
};
const ExecuteSafely = ({
  errorReporter,
  errorMessage
}) => (fn, ...args) => {
  try {
    fn(...args);
  } catch (error) {
    errorReporter.report(_errors.CoreError.of(errorMessage, {
      cause: error
    }));
  }
};
const makeEventHandlersForBehaviors = ({
  dataset,
  connection,
  api
}) => {
  let eventHandlers = {};
  const {
    behaviors,
    properties
  } = connection;
  for (const [behaviorName, behavior] of Object.entries(behaviors)) {
    const makeEventHandlers = eventHandlerMakers[behaviorName];
    if (makeEventHandlers) {
      eventHandlers = {
        ...eventHandlers,
        ...makeEventHandlers({
          dataset,
          properties,
          behavior,
          api
        })
      };
    }
  }
  return eventHandlers;
};
const eventHandlerMakers = {
  input: ({
    behavior: {
      onChange: onChangeProp,
      value: valueProp
    },
    properties: {
      [valueProp]: {
        fieldKey
      }
    },
    api: {
      setFieldValue
    }
  }) => ({
    [onChangeProp]: value => setFieldValue(fieldKey, value)
  }),
  click: settings => actionHandlers[settings.behavior.action](settings)
};
const actionHandlers = {
  next: ({
    behavior: {
      onClick: onClickProp
    },
    api: {
      renderNextRecord
    }
  }) => ({
    [onClickProp]: renderNextRecord
  }),
  previous: ({
    behavior: {
      onClick: onClickProp
    },
    api: {
      renderPrevRecord
    }
  }) => ({
    [onClickProp]: renderPrevRecord
  }),
  nextPage: ({
    behavior: {
      onClick: onClickProp
    },
    api: {
      renderNextPage
    }
  }) => ({
    [onClickProp]: renderNextPage
  }),
  previousPage: ({
    behavior: {
      onClick: onClickProp
    },
    api: {
      renderPrevPage
    }
  }) => ({
    [onClickProp]: renderPrevPage
  }),
  save: ({
    behavior: {
      onClick: onClickProp
    },
    api: {
      saveRecord
    }
  }) => ({
    [onClickProp]: saveRecord
  })

  // TODO: loadMore, applyFilters, resetInputValues, new, revert, delete
  // TODO: focusing of "opposite" components for next, previous, nextPage, previousPage actions
  // TODO: field connection, dynamicPage connection
};
//# sourceMappingURL=bind-behaviors-to-components.js.map